import i18n from '@/lang';
import { isValueEmpty, isPositiveIntegerNum, isNum, isPositiveNum } from '@/utils';

export function validateIncomingOrderNo(rule, value, callback) {
  if (isValueEmpty(value)) {
    callback(new Error(i18n.t('validate.incomingOrderNoCanNotBeEmpty')));
    return false;
  }
  if (!(/^[A-Za-z0-9]+$/.test(value))) {
    callback(new Error(i18n.t('validate.incomingOrderNoFormatError')));
    return false;
  }
  callback();
  return true;
}

export function validateBoxNo(rule, value, callback) {
  if (isValueEmpty(value)) {
    callback(new Error(i18n.t('validate.boxNoCanNotBeEmpty')));
    return false;
  }
  if ((/^\d+$/.test(value))) {
    callback(new Error(i18n.t('validate.boxNoCanNotBePureNumbers')));
    return false;
  }
  if (!(/^[A-Za-z0-9/$#@-]+#[A-Za-z0-9/$#@-]+/.test(value))) {
    callback(new Error(i18n.t('validate.boxNoFormatIncorrect')));
    return false;
  }
  callback();
  return true;
}

export function validateCaseNo(rule, value, callback) {
  if (isValueEmpty(value)) {
    callback(new Error(i18n.t('validate.caseNoCanNotBeEmpty')));
    return false;
  }
  if ((/^\d+$/.test(value))) {
    callback(new Error(i18n.t('validate.caseNoCanNotBePureNumbers')));
    return false;
  }
  if (!(/^[A-Za-z0-9/$#@-]+#[A-Za-z0-9/$#@-]+/.test(value))) {
    callback(new Error(i18n.t('validate.caseNoFormatIncorrect')));
    return false;
  }
  callback();
  return true;
}

export function validateLotNo(rule, value, callback) {
  if (isValueEmpty(value)) {
    callback(new Error(i18n.t('validate.lotNoCanNotBeEmpty')));
    return false;
  }
  if ((/^\d+$/.test(value))) {
    callback(new Error(i18n.t('validate.lotNoCanNotBePureNumbers')));
    return false;
  }
  if (!(/^[A-Za-z0-9/$#@-]+$/.test(value))) {
    callback(new Error(i18n.t('validate.lotNoFormatIncorrect')));
    return false;
  }
  callback();
  return true;
}

export function validateWaferCount(rule, value, callback) {
  if (isValueEmpty(value)) {
    callback(new Error(i18n.t('validate.waferCountCanNotBeEmpty')));
    return false;
  }
  if (!isPositiveIntegerNum(value)) {
    callback(new Error(i18n.t('validate.waferCountMustBeAPositiveInteger')));
    return false;
  }
  callback();
  return true;
}

export function validateCount(rule, value, callback) {
  if (isValueEmpty(value)) {
    callback(new Error(i18n.t('validate.countCanNotBeEmpty')));
    return false;
  }
  if (!isPositiveIntegerNum(value)) {
    callback(new Error(i18n.t('validate.countMustBeAPositiveInteger')));
    return false;
  }
  callback();
  return true;
}

export function validatePrice(rule, value, callback) {
  if (isValueEmpty(value)) {
    callback(new Error(i18n.t('validate.priceCanNotBeEmpty')));
    return false;
  }
  if (!isNum(value)) {
    callback(new Error(i18n.t('validate.priceMustBeANumberInteger')));
    return false;
  }
  if (!(/^(-?\d+)(\.\d{1,2})?$/.test(value))) {
    callback(new Error(i18n.t('validate.priceHasAtMostTwoDecimalPlaces')));
    return false;
  }
  if (Number.parseFloat(value) <= 0) {
    callback(new Error(i18n.t('validate.priceMustBeGreaterThan0')));
    return false;
  }
  callback();
  return true;
}

export function validateContactPhone(rule, value, callback) {
  if (isValueEmpty(value)) {
    callback(new Error(i18n.t('validate.contactPhoneCanNotBeEmpty')));
    return false;
  }
  if (!(/^0?1[0-9][0-9]\d{8}$/.test(value)) || !/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(value)) {
    callback(new Error(i18n.t('validate.contactPhoneFormatIncorrect')));
    return false;
  }
  callback();
  return true;
}

export function validateProductDetails(rule, value, callback) {
  let productId, lotNo, count, endDevicen, isDataEmpty, isAllEmptey = true;
  for (let row of value) {
    productId = row.productId;
    lotNo = row.lotNo;
    count = row.count;
    endDevicen = row.endDevicen;
    isDataEmpty = isValueEmpty(productId) || isValueEmpty(lotNo) || isValueEmpty(count) || isValueEmpty(endDevicen);
    if (isDataEmpty) {
    } else {
      isAllEmptey = false;
      break;
    }
  }
  if (isAllEmptey) {
    callback(new Error(i18n.t('validate.productDetailsCanNotBeEmpty')));
    return false;
  }
  callback();
  return true;
}

export function validateWeight (rule, value, callback) {
  if (isValueEmpty(value)) {
    callback(new Error(i18n.t('validate.weightCanNotBeEmpty')));
    return;
  }
  if (!isNum(value)) {
    callback(new Error(i18n.t('validate.weightMustBeANumber')));
    return;
  }
  if (!isPositiveNum(value)) {
    callback(new Error(i18n.t('validate.weightMustBeAPositiveNumber')));
    return;
  }
  callback();
}
